import {
  HorseShare,
  HorseShareActionResponseTypeEnum,
} from '@sleipai/sleip-models';
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { Action, createReducer, on } from '@ngrx/store';
import * as HorsesShareActions from '../actions/horses-share.actions';

export const horsesShareFeatureKey = 'horses-share';

export interface State extends EntityState<HorseShare> {
  loading: boolean;
  loaded: boolean;
  horseShareSaved: boolean;
  error: string | any | null;
  horseShareActionResponseType: HorseShareActionResponseTypeEnum | null;
}

export function selectHoseShareId(horse: HorseShare) {
  return horse.horseId ?? '';
}

export const adapter: EntityAdapter<HorseShare> =
  createEntityAdapter<HorseShare>({
    selectId: selectHoseShareId,
  });

export const initialState: State = adapter.getInitialState({
  loading: false,
  loaded: false,
  horseShareSaved: false,
  error: null,
  horseShareActionResponseType: null,
});

const horseShareReducer = createReducer(
  initialState,
  on(HorsesShareActions.loadHorseShareInfo, (state) => {
    return {
      ...state,
      loaded: false,
      loading: true,
    };
  }),
  on(HorsesShareActions.loadHorseShareInfoSuccess, (state, { data }) => {
    return adapter.upsertOne(data, {
      ...state,
      loaded: true,
      loading: false,
      error: null,
    });
  }),
  on(HorsesShareActions.loadHorseShareInfoFailure, (state, { error }) => {
    return {
      ...state,
      loaded: true,
      loading: false,
      error: error,
    };
  }),
  on(HorsesShareActions.saveHorseShareInfo, (state) => {
    return {
      ...state,
      loaded: false,
      loading: true,
      error: null,
      horseShareSaved: false,
    };
  }),
  on(HorsesShareActions.stopHorseShare, (state) => {
    return {
      ...state,
      loaded: false,
      loading: true,
      horseShareSaved: false,
    };
  }),
  on(HorsesShareActions.reactivateHorseShare, (state) => {
    return {
      ...state,
      loaded: false,
      loading: true,
      horseShareSaved: false,
    };
  }),
  on(HorsesShareActions.batchShareHorses, (state) => {
    return {
      ...state,
      loading: true,
      error: null,
      horseShareSaved: false,
    };
  }),
  on(
    HorsesShareActions.saveHorseShareInfoSuccess,
    (state, { horseShareActionResponseType }) => {
      return {
        ...state,
        loaded: true,
        loading: false,
        horseShareSaved: true,
        error: null,
        horseShareActionResponseType,
      };
    }
  ),
  on(
    HorsesShareActions.saveHorseShareInfoFailure,
    (state, { error, horseShareActionResponseType }) => {
      return {
        ...state,
        loaded: true,
        loading: false,
        error: error?.message ?? error,
        horseShareActionResponseType,
      };
    }
  ),
  on(HorsesShareActions.resetHorseSharedSavedFlag, (state) => {
    return {
      ...state,
      loaded: true,
      loading: false,
      horseShareSaved: false,
      error: null,
      horseShareActionResponseType: null,
    };
  })
);

// get the selectors
export const {
  selectIds: selectHorseShareIdsAdapter,
  selectEntities: selectHorseShareEntitiesAdapter,
  selectAll: selectAllHorseSharesAdapter,
  selectTotal: selectHorseSharesTotalAdapter,
} = adapter.getSelectors();

export function reducer(state: State | undefined, action: Action) {
  return horseShareReducer(state, action);
}
